export default {
  LIST(state, data) {
    state.monitoringReports = data
  },
  GET(state, data) {
    state.monitoringReport = data
  },
  FILES(state, data) {
    state.files = data
  },
}
